module.exports = __webpack_public_path__ + "static/media/mr.0836d135.webp";